import { Fragment, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { BlueprintConditionsValue, BooleanOperators } from '@zinnia/form-engine-sdk';

export function BooleanOperatorView({
  conditions,
  index,
}: {
  conditions: BlueprintConditionsValue;
  index: number;
}): ReactElement | null {
  const { t } = useTranslation();

  if (index === conditions.conditions.length - 1 || !conditions.booleanOperator) {
    return null;
  }

  return (
    <Fragment>
      {conditions.booleanOperator === BooleanOperators.not
        ? ` ${t(BooleanOperators.and).toUpperCase()} `
        : ` ${t(conditions.booleanOperator).toUpperCase()} `}
    </Fragment>
  );
}
